export default __webpack_public_path__ + "static/bestie-2-91a215aca9e1f7c496af34b82e703f86.webp";